import { render, staticRenderFns } from "./QuotationStepInsured2.vue?vue&type=template&id=ca5cac1a"
import script from "./QuotationStepInsured2.vue?vue&type=script&lang=js"
export * from "./QuotationStepInsured2.vue?vue&type=script&lang=js"
import style0 from "./QuotationStepInsured2.vue?vue&type=style&index=0&id=ca5cac1a&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports